/**
 * Desktop menu UI component.
 * See Figma designs: https://www.figma.com/file/YQ73BIauH99X8ksuCY1hcZ/Marketing---website-content-blueprint?type=design&node-id=740-3865&t=kQ83llMh84LyGzLD-4
 */
const DesktopMenu = (function () {
  // DOM elements
  const headerEl = document.querySelector('.js-header')
  const toggleSubMenuBtnEls = headerEl.querySelectorAll('.js-toggle-sub-menu')
  const tier2Links = headerEl.querySelectorAll('.js-tier-2-link')

  // Menu state
  let menuState = {
    activeSubMenuId: '',
  }

  /**
   * Initialise event listeners for sub menu toggle buttons. Also force close any
   * open sub menus on link clicks as menu state is retained on page transition
   * with Barba.js library (see /behaviours/page-transitions/index.js)
   */
  const initDesktopMenu = () => {
    toggleSubMenuBtnEls.forEach((toggleBtn) => {
      toggleBtn.addEventListener('click', handleSubMenuToggleBtnClick)
    })
    tier2Links.forEach((subMenuLink) => {
      subMenuLink.addEventListener('click', closeActiveSubMenu)
    })
  }

  /**
   * Remove active event listeners
   */
  const killDesktopMenu = () => {
    closeActiveSubMenu()
    toggleSubMenuBtnEls.forEach((toggleBtn) => {
      toggleBtn.removeEventListener('click', handleSubMenuToggleBtnClick)
    })
    tier2Links.forEach((subMenuLink) => {
      subMenuLink.removeEventListener('click', closeActiveSubMenu)
    })
    const toggleBtn = headerEl.querySelector(`[data-submenu="${menuState.activeSubMenuId.substring(1)}"]`)
    if (toggleBtn) {
      toggleBtn.classList.remove('c-main-nav__link--sub-menu-open')
      toggleBtn.setAttribute('aria-expanded', 'false')
    }
    document.removeEventListener('click', handleClickOutsideSubMenu)
    headerEl.removeEventListener('keydown', handleMenuEscape)
  }

  /**
   * Handle click on top level links which have sub menus.
   * Target menu to toggle is stored in `data-submenu` attribute on button el.
   */
  const handleSubMenuToggleBtnClick = (e) => {
    e.stopPropagation()
    const subMenuId = `#${e.target.dataset.submenu}`

    // Check if menu to toggle is already open
    const isOpenSubMenu = menuState.activeSubMenuId === subMenuId

    // If sub menu already open, close it first
    closeActiveSubMenu()

    if (!isOpenSubMenu) {
      const subMenuEl = headerEl.querySelector(subMenuId)
      if (subMenuEl) {
        /**
         * Apply classes for active state styling to both button and drop down.
         */
        subMenuEl.style.display = 'flex'
        requestAnimationFrame(() => {
          subMenuEl.classList.add('c-main-nav__sub-menu-container--active')
          e.target.classList.add('c-main-nav__link--sub-menu-open')

          // Toggle expanded attribute for a11y
          e.target.setAttribute('aria-expanded', 'true')

          // Update menu state to reflect changes
          menuState.activeSubMenuId = subMenuId

          // Sub menu should close if user clicks anywhere outside of drop down or presses esc
          document.addEventListener('click', handleClickOutsideSubMenu)
          headerEl.addEventListener('keydown', handleMenuEscape)
        })
      }
    }
  }

  const handleMenuEscape = (e) => {
    if (e.key === 'Escape') {
      const toggleBtn = headerEl.querySelector(`[data-submenu="${menuState.activeSubMenuId.substring(1)}"]`)
      if (toggleBtn) {
        toggleBtn.focus()
      }
      closeActiveSubMenu()
    }
  }

  /**
   * Find active sub menu and close it, update menu state and styling, remove event listeners
   */
  const closeActiveSubMenu = () => {
    if (!menuState.activeSubMenuId) return

    const activeSubMenuEl = headerEl.querySelector(menuState.activeSubMenuId)
    if (activeSubMenuEl) {
      activeSubMenuEl.classList.remove('c-main-nav__sub-menu-container--active')
      activeSubMenuEl.style.display = ''

      const toggleBtn = headerEl.querySelector(`[data-submenu="${menuState.activeSubMenuId.substring(1)}"]`)
      if (toggleBtn) {
        toggleBtn.setAttribute('aria-expanded', 'false')
        toggleBtn.classList.remove('c-main-nav__link--sub-menu-open')
      }
      menuState.activeSubMenuId = ''
      document.removeEventListener('click', handleClickOutsideSubMenu)
      headerEl.removeEventListener('keydown', handleMenuEscape)
    }
  }

  /**
   * Handle click outside of active sub menu to trigger close.
   */
  const handleClickOutsideSubMenu = (e) => {
    const activeSubMenuEl = headerEl.querySelector(menuState.activeSubMenuId)
    if (activeSubMenuEl) {
      if (!activeSubMenuEl.contains(e.target)) {
        closeActiveSubMenu()
      }
    }
  }

  return {
    init: () => {
      initDesktopMenu()
    },
    kill: () => {
      killDesktopMenu()
    },
    closeMenu: () => {
      closeActiveSubMenu()
    },
  }
})()

export default DesktopMenu
